module.exports = __webpack_public_path__ + "static/yoga-bf13bf4262142e0b636dff592f108450.png";